import React, { useState } from 'react';
import { Item } from '../../items/item';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import Slider from "react-slick";
import { SiteLink } from '../../../components';

export function BannerPanel(props) {
  const item = props.item;
  const subItems = item.items || [];
  const cmsOption = props.cmsOption || {};

  // add state to track current slide index
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  //console.log('item', item, subItems);

  const heightSet = cmsUtils.payload(item, 'HeightSet') || 'standard';

  const slides = subItems.map((subItem, index) =>
    <Item item={subItem} key={subItem.itemId} cmsOption={cmsOption}></Item>
  );

  // console.log('James subItems:', item, subItems);

  // getCaptionButtonValue from payloads
  const getCaptionButtonValue = (payloads) => {
    if (!payloads || !Array.isArray(payloads)) return 'VIEW ALL';
    const captionButtonItem = payloads.find(payload => payload.key === 'CaptionButton');
    return captionButtonItem ? captionButtonItem.value : 'VIEW ALL';
  };

  // getLinkUrlValue from payloads
  const getLinkUrlValue = (payloads) => {
    if (!payloads || !Array.isArray(payloads)) return '/';
    const linkUrlItem = payloads.find(payload => payload.key === 'LinkUrl');
    return linkUrlItem ? linkUrlItem.value : '/';
  };

  // getCaptionButtonValue from currentSlideIndex
  const captionButtonText = subItems.length > 0 && subItems[currentSlideIndex]
    ? getCaptionButtonValue(subItems[currentSlideIndex].payloads)
    : 'VIEW ALL';

  // getLinkUrlValue from currentSlideIndex
  const linkUrl = subItems.length > 0 && subItems[currentSlideIndex]
    ? getLinkUrlValue(subItems[currentSlideIndex].payloads)
    : '/';

  var settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    autoplaySpeed: 3000,
    fade: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (current, next) => {
      setCurrentSlideIndex(next);
    }
  };

  const cssClass = utils.classNames('cms_item', 'bannerPanel', `bannerWrapperSize--${heightSet}`, item.cssClass || item.anchorName || '');

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName} style={{ position: 'relative' }}>
      <Slider {...settings} >
        {slides}
      </Slider>
      <div
        className="banner-panel-line-section"
        style={{
          transition: 'opacity 0.3s ease-in-out'
        }}
      >
        <SiteLink to={linkUrl} className="banner-panel-line-section__link">{captionButtonText}</SiteLink>
      </div>
    </div>
  );
}